<script setup>
import { computed } from 'vue';

const props = defineProps({
  percent: {
    type: Number,
    default: 0,
  },
  showDot: {
    type: Boolean,
    default: false,
  },
  height: {
    type: [Number, String],
    default: 10,
  },
  dotSize: {
    type: [Number, String],
    default: 10,
  },
  dotOffset: {
    type: [Number, String],
    default: 8,
  },
  trackColor: {
    type: String,
    default: '#bcc2cd',
  },
  fillColor: {
    type: String,
    default: '#1DAB8B',
  },
});

const normalizeSize = (value) => {
  return typeof value === 'number' ? `${value}px` : value;
};

const clampedPercent = computed(() => {
  return Math.max(0, Math.min(100, props.percent));
});

const rootStyle = computed(() => {
  return {
    '--service-savings-progress-height': normalizeSize(props.height),
    '--service-savings-progress-dot-size': normalizeSize(props.dotSize),
    '--service-savings-progress-dot-offset': normalizeSize(props.dotOffset),
    '--service-savings-progress-track-color': props.trackColor,
    '--service-savings-progress-fill-color': props.fillColor,
  };
});
</script>

<template>
  <div
    class="service-savings-progress"
    :style="rootStyle"
  >
    <div
      class="service-savings-progress__fill"
      :style="{ width: `${clampedPercent}%` }"
    />
    <div
      v-if="showDot"
      class="service-savings-progress__dot"
    />
  </div>
</template>

<style scoped>
  .service-savings-progress {
    position: relative;
    width: 100%;
    height: var(--service-savings-progress-height);
    border-radius: 999px;
    background-color: var(--service-savings-progress-track-color);
    overflow: hidden;
  }
  .service-savings-progress__fill {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-radius: 999px;
    background-color: var(--service-savings-progress-fill-color);
    transition: width 0.4s ease-out;
  }
  .service-savings-progress__dot {
    position: absolute;
    top: 50%;
    left: var(--service-savings-progress-dot-offset);
    width: var(--service-savings-progress-dot-size);
    height: var(--service-savings-progress-dot-size);
    border-radius: 50%;
    background-color: var(--service-savings-progress-fill-color);
    transform: translateY(-50%);
  }
</style>
